import { palette } from '@/styles/figma-tokens';

interface AnalyticsIconProps {
  className?: string;
}

export default function UploadFileIcon({ className }: AnalyticsIconProps) {
  return (
    <svg width="95" height="75" viewBox="0 0 95 75" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        opacity="0.48"
        d="M47.3371 38.5458C47.2555 52.9224 47.0921 74.921 47.3363 74.964C47.6997 74.964 48.0632 74.9115 48.4152 74.8065L82.1652 64.6814C82.9377 64.4496 83.6148 63.9748 84.0961 63.3277C84.5774 62.6805 84.8372 61.8955 84.8371 61.089V26.3789L47.3371 38.5458Z"
        className="fill-grey-400"
      />
      <path
        opacity="0.48"
        d="M47.2586 38.5203L9.83708 26.3789L9.83691 61.0889C9.83674 61.8954 10.0966 62.6805 10.5779 63.3276C11.0592 63.9748 11.7363 64.4495 12.5088 64.6814L46.2588 74.8064C46.6104 74.9114 46.9734 74.9639 47.3365 74.9639C47.0919 74.9424 47.177 52.904 47.2586 38.5203Z"
        className="fill-grey-300"
      />
      <path
        opacity="0.8"
        d="M47.337 38.5458L9.83697 26.3789L0.321341 40.4864C0.158687 40.7272 0.0542095 41.0024 0.0161533 41.2905C-0.0219028 41.5785 0.00750335 41.8715 0.102052 42.1462C0.196601 42.4209 0.353704 42.6699 0.560965 42.8736C0.768226 43.0772 1.01997 43.2299 1.29634 43.3195L35.037 54.2808C35.4236 54.4065 35.8405 54.4031 36.225 54.2712C36.6096 54.1393 36.9408 53.886 37.1688 53.5495L47.337 38.5458Z"
        fill="url(#paint0_linear_7048_197505)"
      />
      <path
        opacity="0.8"
        d="M84.8369 26.3789L47.3369 38.5458L57.505 53.5495C57.7331 53.886 58.0643 54.1393 58.4488 54.2712C58.8334 54.4031 59.2503 54.4065 59.6369 54.2808L93.3775 43.3195C93.6539 43.2299 93.9057 43.0772 94.1129 42.8736C94.3202 42.6699 94.4773 42.4209 94.5718 42.1462C94.6664 41.8715 94.6958 41.5785 94.6577 41.2905C94.6197 41.0024 94.5152 40.7272 94.3525 40.4864L84.8369 26.3789Z"
        fill="url(#paint1_linear_7048_197505)"
      />
      <path
        opacity="0.64"
        d="M38.2569 1.41721C38.0284 1.08175 37.6973 0.82948 37.3132 0.698297C36.9291 0.567114 36.5128 0.564099 36.1269 0.689707L2.38437 11.6528C2.1078 11.7419 1.85579 11.8942 1.64828 12.0976C1.44078 12.301 1.28349 12.5499 1.18889 12.8247C1.09428 13.0994 1.06495 13.3924 1.10322 13.6804C1.14149 13.9684 1.2463 14.2436 1.40937 14.4841L9.83374 26.9753L47.3337 14.7672L38.2569 1.41721Z"
        fill="url(#paint2_linear_7048_197505)"
      />
      <path
        opacity="0.64"
        d="M93.2613 13.8864C93.4236 13.6457 93.5277 13.3706 93.5656 13.0828C93.6034 12.795 93.5739 12.5023 93.4794 12.2278C93.3849 11.9533 93.2279 11.7045 93.0209 11.501C92.8138 11.2976 92.5624 11.1449 92.2863 11.0552L58.5438 0.0920507C58.1578 -0.033557 57.7416 -0.0305424 57.3575 0.100641C56.9734 0.231824 56.6423 0.484093 56.4138 0.819552L47.3369 14.1696L84.8369 26.3777L93.2613 13.8864Z"
        fill="url(#paint3_linear_7048_197505)"
      />
      <path
        opacity="0.48"
        d="M84.8369 26.3761L47.3369 14.168L9.83691 26.3761L47.3369 38.543L84.8369 26.3761Z"
        className="fill-grey-400"
      />
      <path
        opacity="0.48"
        d="M47.3369 26.2739V14.5977L9.83691 26.8058L47.3369 38.9727V26.2739Z"
        className="fill-grey-400"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7048_197505"
          x1="10.0863"
          y1="26.3639"
          x2="15.3274"
          y2="61.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={palette.grey['100']} />
          <stop offset="1" stop-color={palette.grey['400']} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7048_197505"
          x1="47.4888"
          y1="38.4183"
          x2="87.0207"
          y2="61.1544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={palette.grey['100']} />
          <stop offset="1" stop-color={palette.grey['400']} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7048_197505"
          x1="4.92499"
          y1="19.6985"
          x2="10.5819"
          y2="-6.96834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={palette.grey['100']} />
          <stop offset="1" stop-color={palette.grey['400']} />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7048_197505"
          x1="57.3757"
          y1="-0.359824"
          x2="59.3984"
          y2="32.5553"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={palette.grey['100']} />
          <stop offset="1" stop-color={palette.grey['400']} />
        </linearGradient>
      </defs>
    </svg>
  );
}
